import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import {
  AgencySettingsUpdatePayload,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';

type UpdateRateMultiplierArgs = AgencySettingsUpdatePayload & {
  enumId: IntegrationEnum;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<unknown, BaseErrorResponse, UpdateRateMultiplierArgs>,
  'mutationFn' | 'mutationKey'
>;

const updateRateMultiplier = async ({
  enumId,
  rateMultiplier,
}: UpdateRateMultiplierArgs) => {
  const response = await API.patch(
    `/api/internal/integrations/default/${enumId}/agency-settings`,
    { rateMultiplier },
  );
  return response.data;
};

const useUpdateRateMultiplierMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: updateRateMultiplier,
    ...options,
  });
};

export default useUpdateRateMultiplierMutation;
